/**
 * Shared scrim treatments for `DialogContent` / `SheetContent`, both of which
 * take an `overlayClassName`.
 *
 * Before this existed, every hand-rolled overlay picked its own opacity, blur
 * radius and z-index — the codebase carried three of each. Add a constant here
 * rather than inlining a new combination at a call site.
 */

/** Light dim + slight blur. The default for panels and non-blocking dialogs. */
export const OVERLAY_SOFT = "bg-black/20 backdrop-blur-[0.1875rem]";

/** Raises the scrim above a dialog that is already open. */
export const OVERLAY_NESTED = "z-[60] bg-black/40";
